import React from "react";
import "./toggle-switch.css";

const ToggleSwitch = ({
  checked,
  onChange = ()=>{} ,
  id,
  name = "toggleChecked",
  leftLabel,
  rightLabel,
  disabled = false,
  size = "md",
  containerStyle = {}
}) => {
  const bothLabels = leftLabel && rightLabel;

  const sizeMap = {
    sm: { width: 46, height: 16, circle: 12, translate: 30 },
    md: { width: 48, height: 24, circle: 20, translate: 24 },
    lg: { width: 64, height: 32, circle: 28, translate: 32 },
  };

  const { width, height, circle, translate } = sizeMap[size] || sizeMap.md;

  return (
    <div className="toggle-container" style={containerStyle}>
      
      {leftLabel && (
        <span
          className={`toggle-label ${
            bothLabels
              ? checked
                ? "active-label"
                : "inactive-label"
              : checked
              ? "active-label"
              : "inactive-label"
          }`}
          onClick={() => !disabled && onChange(id, name, true)}
        >
          {leftLabel}
        </span>
      )}

      <div
        className={`toggle-switch ${checked ? "active" : "inactive"} ${
          disabled ? "disabled" : ""
        }`}
        onClick={() => !disabled && onChange(id, name, !checked)}
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <div
          className="toggle-circle"
          style={{
            width: `${circle}px`,
            height: `${circle}px`,
            top: `${(height - circle) / 2}px`,
            transform: checked
              ? "translateX(0)"
              : `translateX(${translate}px)`,
          }}
        />
      </div>

      {rightLabel && (
        <span
          className={`toggle-label right ${
            bothLabels
              ? !checked
                ? "active-label"
                : "inactive-label"
              : !checked
              ? "active-label"
              : "inactive-label"
          }`}
          onClick={() => !disabled && onChange(id, name, false)}
        >
          {rightLabel}
        </span>
      )}
    </div>
  );
};

export default ToggleSwitch;